<template>
  <div :id="componentId" class="sp-four-module-three">
    <div class="gallery">
      <!-- 左箭头 -->
      <img
        class="arrow arrow-left"
        referrerpolicy="no-referrer"
        src="../../SpecialOne/assets/img/FigmaDDSSlicePNG99bb8919a69e1287d3f76ac4a83127c7.png"
        @click="prev"
      />

      <!-- 当前图片 -->
      <div class="current-image" v-if="items.length > 0">
        <img
          class="gallery-image"
          referrerpolicy="no-referrer"
          :src="activeImage.imageUrl"
        />
      </div>

      <!-- 右箭头 -->
      <img
        class="arrow arrow-right"
        referrerpolicy="no-referrer"
        src="../../SpecialOne/assets/img/FigmaDDSSlicePNG33a817cb60e4551109bd46ed91b16c20.png"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpFourModule3',
  props: {
    componentId: {
      type: String,
      default: 'sp_four_module_3'
    },
    pageModules: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      backgroundColor: '#FFFFFF',
      items: [
        {
          imageUrl: 'https://image.cbrand.com.cn/default/2026/09/306647FC76814925B284DF907E6E828B.png',
          jumpType: 1,
          linkAddress: ''
        }
      ],
      activeIndex: 0
    }
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor
      }
    },
    activeImage() {
      if (this.items.length === 0) return { imageUrl: '', jumpType: 1, linkAddress: '' }
      return this.items[this.activeIndex] || this.items[0]
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return
      window.open(item.linkAddress, '_blank')
    },
    prev() {
      if (this.items.length === 0) return
      this.activeIndex = (this.activeIndex - 1 + this.items.length) % this.items.length
    },
    next() {
      if (this.items.length === 0) return
      this.activeIndex = (this.activeIndex + 1) % this.items.length
    }
  }
}
</script>

<style scoped>
.sp-four-module-three {
  position: relative;
  width: 1400px;
  min-width: 1400px;
  max-width: 1400px;
  left: 50%;
  transform: translateX(-50%);
  padding: 30px 0;
}

.gallery {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 40px 46px;
}

/* 当前图片容器 */
.current-image {
  width: 1308px;
  height: auto;
  overflow: hidden;
}

.gallery-image {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

/* 左右箭头 */
.arrow {
  position: absolute;
  top: 50%;
  width: 46px;
  height: 46px;
  margin-top: -23px;
  z-index: 30;
  cursor: pointer;
}

.arrow-left {
  left: 0;
}

.arrow-right {
  right: 0;
}
</style>
